// Like 'useBreakpoints' from VueUse, but with predefined breakpoints from the plugin config file
// @see https://vueuse.org/core/usebreakpoints/#usebreakpoints

import { useBreakpoints, type ConfigurableWindow } from '@vueuse/core'
import config from '@/plugin-config.json'

export function useScreen(options?: ConfigurableWindow) {
  return useBreakpoints(config.breakpoints, options)
}
